export default {
	API: {
		CUSTOMERS: {
			V1_LIST: "/api/customers/pure-list",
			ALL: "/api/v2/customers/pure-all",
			LIST: "/api/v2/customers/list",
			EXPORT_YIELD: "/api/v2/customers/export-yield",
			EXPORT: "/api/v2/customers/export",
			EXPORT_RAW_POND: "/api/v2/customers/export-raw-data",
			GET_CUSTOMER: "/api/v2/customers/",
			CREATE_CUSTOMER: "/api/customers/create",
			UPDATE_CUSTOMER: "/api/customers/",
			DELETE_CUSTOMER: "/api/customers/delete/",
			DELETE_CUSTOMER_V2: "/api/v2/customers/delete",
			CUSTOMER_V2: "/api/v2/customers/",
		},
		PRODUCTS: {
			LIST: "/api/products",
			ORDERS_BY_PRODUCT: "/api/orders-by-product",
			ORDER_BY_ID: "/api/order-by-id",
			ORDERS_BY_ME: "/api/orders-by-me",
			SELLS_LIST: "/api/sell-list",
			ORDER_CREATE: "/api/order",
			ORDER_CANCEL: "/api/order-cancel",
		},
		SUPPLIERS: {
			LIST: "/api/suppliers",
		},
		PLACES: {
			LIST: "/api/places",
			PROVINCES: "/api/provinces",
			DISTRICTS: "/api/districts",
		},
		MATCHINGS: {
			CONFIRM_BUY: "/api/order-confirm-buy",
			GET_SHIPPING_BY_ID: "/api/shipping-by-id",
			LIST: "/api/matchings",
			LIST_SHIPPINGS: "/api/shippings",
			BY_ID: "/api/matching",
			MATCH_PRICE: "/api/orders-matching-price",
			SAVE_SHIPPING: "/api/matchings/save-shipping",
			DONE_SHIPPING: "/api/matchings/done-shipping",
			KCS_REVIEW_SHIPPING: "/api/matchings/kcs-review-shipping",
			PAYMENT_INFO: "/api/matchings/set-payment-info",
			PAYMENT_INFO_AQUA: "/api/matchings/set-payment-info-aqua",
			RATING_BUYER: "/api/matchings/rating-buyer"
		},
		USERS: {
			LOGIN: "/api/users/login",
			CREATE: "/api/users",
			CHANGE_PASSWORD: "/api/users/change-password",
			LIST: "/api/v2/users/list",
			LIST2: "/api/v2/users/list2",
			LIST3: "/api/v2/users/list3",
			DELETE_USER: "/api/v2/users/delete/",
			UPDATE_USER: "/api/v2/users/list",
			ASSIGN: "/api/v2/users/assign",
			EXPORT: "/api/v2/users/export",
		},
		ADDRESSES: {
			PROVINCE: "/api/addresses/province/list",
			DISTRICT: "/api/addresses/district/list",
			WARD: "/api/addresses/ward/list",
		},
		PONDS: {
			LIST: "/api/v2/ponds/list",
			GET: "/api/v2/ponds/",
			CREATE: "/api/ponds/create",
			UPDATE: "/api/ponds/",
			UPDATE_DAILY: "/api/ponds/update-data/",
			DELETE: "/api/v2/ponds/delete/",
		},
		STATISTIC: {
			YIELD: "/api/v2/statistic/yield",
		},
		TRACKING: {
			LIST: "/api/tracking/list",
			DETAIL: "/api/tracking/",
		},
	},
};
